import React, { useContext, useMemo, useState } from 'react';
import { Company } from '../../../../types/company';
import { CompanyRoleAssignment } from '../../../../types/company_role_assignment/companyRoleAssignment';
import { FileEntityType } from '../../../../types/file';
import { FileViewLoader } from '../../../../VentoryUI/components/common/File';
import { VentoryColor } from '../../../../VentoryUI/util/color.util';
import { ReactComponent as VentoryWhiteLogo } from '../../../../assets/img/Ventory-WhiteNoBack.svg';
import { storeCurrentCompanyId } from '../../../../util/token.util';
import { useNavigate } from 'react-router-dom';
import { CompanyContext } from '../../../../context/CompanyContext';
import { CompanyRoleAssignmentUtil } from '../../../../types/company_role_assignment/companyRoleAssignment.util';
import { Card } from '../../../components/Card';
import { IconButton } from '../../../icons';
import { IconType } from '../../../icons/Icon';
import { t } from '../../../../types/translation/Translator';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import DeleteCompanyRoleAssignmentModal from '../../Settings/User/Update/Roles/DeleteCompanyRoleAssignmentModal';

interface CompanyItemProps {
  company: Company;
  assignment?: CompanyRoleAssignment;
}

export default function CompanyItem({ company, assignment }: CompanyItemProps) {
  const navigate = useNavigate();

  const { refreshCompany } = useContext(CompanyContext);

  const [leaveCompanyModalOpen, setLeaveCompanyModalOpen] = useState(false);

  const logo = useMemo(() => {
    if (company.settings.companyLogo) {
      return (
        <FileViewLoader
          className={'object-scale-down'}
          fileId={company.settings.companyLogo}
          fileEntityType={FileEntityType.company}
          companyId={company.id}
        />
      );
    } else {
      return (
        <VentoryWhiteLogo className={'object-scale-down'} color={VentoryColor.grey500} stroke={VentoryColor.grey500} />
      );
    }
  }, [company]);

  const handleClick = () => {
    storeCurrentCompanyId(company.id);
    refreshCompany(company.id);
    navigate('/dashboard');
  };

  return (
    <>
      {assignment && leaveCompanyModalOpen && (
        <DeleteCompanyRoleAssignmentModal
          assignment={assignment}
          open={leaveCompanyModalOpen}
          setOpen={setLeaveCompanyModalOpen}
        />
      )}

      <Card size='lg' onClick={handleClick}>
        <div className='flex w-full flex-col items-center justify-center gap-2'>
          <div
            className={`flex h-12 w-full items-center justify-center`}
            style={{ backgroundColor: company.settings.headerColor }}
          >
            {logo}
          </div>
          <p className='w-full break-words text-center font-medium text-black'>{company.name}</p>
          {assignment && (
            <p className='grid w-fit place-items-center rounded-full bg-gray-300 px-[6.5px] py-[1.5px] text-xs'>
              {CompanyRoleAssignmentUtil.roleToString(assignment.role)}
            </p>
          )}
        </div>

        {assignment && (
          <div className='absolute bottom-2 right-2'>
            <IconButton
              text={t(TranslationKey.leaveCompany).singular.upper}
              type={IconType.logOut1}
              onClick={() => setLeaveCompanyModalOpen(true)}
              stroke={'stroke-gray-500'}
            />
          </div>
        )}
      </Card>
    </>
  );
}
